import { render, staticRenderFns } from "./LockPlatform.vue?vue&type=template&id=44aef43e"
import script from "./LockPlatform.vue?vue&type=script&lang=js"
export * from "./LockPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports